<script lang="ts">
  import { derived } from "svelte/store";
  import Score from "./Score.svelte";
  import { fade } from "svelte/transition";
  import { data } from "./data.ts";

  // type imports are not working... but compiler is not complaining anyhow..
  // import { Question } from './questions.ts';
  
  let showScoreRequired = false;

  export let question: Question;
   export function tryNext() {
     if (question.score && !$data.questions[question.name].score) {
       showScoreRequired = true;
       return false;
     }
    return true;
  }
</script>

<style>
  div.error {
    display: inline-block;
    color: white;
    background-color: red;
    padding: 4px;
    border-radius: 4px;
    margin-bottom: 4px;
  }
</style>

<div>
  <h2>{question.name}</h2>
  <ul>
    {#each question.descriptionItems as item}
      <li>{item}</li>
    {/each}
  </ul>
  {#if question.score}
    {#if showScoreRequired}
      <div in:fade class="error">Verplicht</div>
    {/if}
    <Score bind:value={$data.questions[question.name].score} />
  {/if}
  {#if question.details}
    <textarea bind:value={$data.questions[question.name].details} placeholder="Uitleg" />
  {/if}
</div>
